/* eslint-disable */
import  { useState, useEffect, useCallback } from "react"; 
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import {Table, Row, Col, Tooltip, Button, Badge, Popover, Collapse} from "antd";
import type { ColumnsType } from 'antd/es/table';
import {PlusCircleOutlined, MinusOutlined, PlusOutlined, CarryOutFilled, DeleteOutlined} from "@ant-design/icons";
import { toSentenceCase } from "../../utils/utils"
import ReactECharts from 'echarts-for-react';
import "./index.scss";
import NewEditTable from "../../components/NewEditTable";
import { formatValue, formatHistoryValue, formatTime, formatHistoryTime } from '../../utils/auth';
const { Panel } = Collapse;
const IELibrary = (props) => { 
  const {
    scenario, 
    IEType, 
    saveCriteria, 
    readOnlyAccess, 
    isAdmin, 
    protocolRateData, 
    inActiveChartColors, 
    defaultChartValue, 
    impactColors, 
    amend_avg_rate, 
    showChartLabel,
    par_historical_trial_average,
    criteria_par_amendment_count, 
    criteria_count, 
    protocol_amendment_rate, 
    sfr_historical_trial_average, 
    criteria_sfr_amendment_count, 
    screen_failure_rate, 
    screen_avg_rate, 
    screenRateData, 
    updateCriteria,
    defaultActiveKey, 
    collapsible,  
    demographicsTableData, 
    medConditionTableData, 
    interventionTableData, 
    labTestTableData, 
    insightEvent, 
    onDismiss, 
    onInsightClick, 
    demographicsElements,
    interventionElements,
    medConditionElements,
    labTestElements,
    originDemographics,
    originIntervention, 
    originMedCondition, 
    originLabTest,
    excluActive,
    readOnly 
  } = props
  
  const [eventLib, setEventLib] = useState(6)
  const [eventPanel, setEventPanel] = useState("1")
  
  const [iELibrarayPanelStatus, setIELibraryPanelStatus] = useState(false)

  const ieInsightsToggleHandler = (status) => {
    setIELibraryPanelStatus(status);
    setEventLib(!status ? 0 : 6)
  }

 

  const labelColors = {LOW: '#00A947', MEDIUM: '#0084A9', HIGH: '#c33232'}

  const amendmentRateoption = {
    tooltip: {
      show: showChartLabel,
      trigger: 'item',
      formatter: '{b} - {d}%',
      extraCssText:'background:white;color:#757373;font-size:12px'
    },
    series: [
      {
        type: 'pie',
        center: ['center', '55%'],
        radius: ['60%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        
        emphasis: {
          disabled: true,
          label: {
            show: true,
            fontSize: '12',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        color: impactColors,
        data: protocolRateData
      }
    ],
    graphic: {
      elements: [{
        type: 'text',
        left: 'center',
        top: '47%', 
        cursor:'default',
        invisible: false,
        style: {
          text: amend_avg_rate.split('\n')?
            (amend_avg_rate.split('\n')[0] === ''?'-': amend_avg_rate.split('\n')[0]):'-',
          fontSize: 30,
          textAlign: 'center', 
          width: 30,
          height: 30,
          fill: '#848484'
        }
      },
    ]
    },
  };

  const screenFailureOption = {
    tooltip: {
      show: showChartLabel,
      trigger: 'item',
      formatter: '{b} - {d}%',
      extraCssText:'background:white;color:#757373;font-size:12px'
    },
    series: [
      {
        type: 'pie',
        center: ['center', '55%'],
        radius: ['60%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          disabled: true,
          label: {
            show: true,
            fontSize: '12',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        color: impactColors,
        data: screenRateData
      }
    ],
    graphic: {
      elements: [{
        type: 'text',
        left: 'center',
        top: 'center', 
        cursor:'default',
        invisible: false,
        style: {
          text: screen_avg_rate.split('\n')?
            (screen_avg_rate.split('\n')[0] === ''?'-': toSentenceCase(screen_avg_rate.split('\n')[0])):'-',
          fontSize: 30,
          textAlign: 'center', 
          width: 30,
          height: 30,
          fill: '#848484'
        }
      },
      {
        type: 'text',
        left: 'center',
        top: '60%',
        cursor:'default',
        invisible: !showChartLabel,
        style: {
          text: screen_avg_rate.split('\n')? toSentenceCase(screen_avg_rate.split('\n')[1]):"",
          fontSize: 12,
          textAlign: 'center',
          fontWeight:'bold',
          width: 30,
          height: 25,
          fill: screen_avg_rate.split('\n')&&screen_avg_rate.split('\n')[1]=="LOW"?
          labelColors.LOW:
          screen_avg_rate.split('\n')&&screen_avg_rate.split('\n')[1]=="MEDIUM"?
          labelColors.MEDIUM:
          labelColors.HIGH,
        }
      }]
    },
  };

  const pieChartNullOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{b} - {d}%',
      extraCssText:'background:white;color:#757373;font-size:12px'
    },
    series: [
      {
        type: 'pie',
        center: ['center', '55%'],
        radius: ['60%', '90%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
        },
        emphasis: {
          disabled: true,
          label: {
            show: true,
            fontSize: '12',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        color: inActiveChartColors,
        data: defaultChartValue,
      }
    ],
    graphic: {
      elements: [{
        type: 'text',
        left: 'center',
        top: '45%', 
        cursor:'default',
        invisible: false,
        style: {
          text: '-',
          fontSize: 30,
          textAlign: 'center', 
          width: 30,
          height: 30,
          fill: '#848484'
        }
      }]
    },
  };

  interface DataType {
    key: number;
    category: string;
    criteria: string;
    rate: number;
  }

  const columnsSFR: ColumnsType<DataType> = [
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Entity',
      dataIndex: 'criteria',
      key: 'criteria',
    },
    {
      title: 'Screen Failure',
      dataIndex: 'rate',
      key: 'rate',
      render: val => (Math.round(val * 10000) / 100 + "%")
    }
  ];

  const detailContent = (detailData) => {
    switch (detailData) {
      case 'PAR':
        return 
      case 'SFR':
        return (
          <Table columns={columnsSFR} dataSource={scenario&&scenario['highest_screen_failure_rate']&&scenario['highest_screen_failure_rate'][IEType.slice(0,9)]?scenario['highest_screen_failure_rate'][IEType.slice(0,9)]:[]} pagination={false} size={'small'}/>
          )
      default:
        break;
    }
  }

  const showIEPage = () => {
    if(IEType==='Inclusion Criteria') {
      props.updateIEActivities({
        demographicsElements:demographicsElements,
        interventionElements:interventionElements,
        medConditionElements:medConditionElements,
        labTestElements:labTestElements,
      })
    } else if(IEType==='Exclusion Criteria') {
      props.updateIEActivities({
        excluDemographicsElements:demographicsElements ,
        excluMedConditionElements: medConditionElements,
        excluInterventionElements: interventionElements,
        excluLabTestElements: labTestElements,
      })
    }
    
    props.history.push({
      pathname: '/add-activity-ie',
      state: {
        IEType,
        readOnly,
        originDemographics,
        originIntervention,
        originMedCondition,
        originLabTest,

        demographicsSelected:demographicsElements,
        interventionSelected:interventionElements,
        medConditionSelected:medConditionElements,
        labTestSelected:labTestElements,
        
        similarHistoricalTrials: props.similarHistoricalTrials,
        trial_id: props.trial_id,
        scenarioId: props.scenarioId, 
        scenarioType: props.scenarioType,
        }
      })
  }

  const onClickPARDetail = () => {
    props.history.push({
      pathname: '/show-pa',
      state: {
        paData: scenario&&scenario['amendment_details']&&scenario['amendment_details']?scenario['amendment_details']:{},
        similarHistoricalTrials: props.similarHistoricalTrials,
        trial_id: props.trial_id,
        scenarioId: props.scenarioId, 
        scenarioType: props.scenarioType,
        }
      })
  }

  const filterAddedInsights = (insights) => insights.filter((insight) => {
    if (insight.category === "Demographics" && insight.action === "ADD"
    ) {
      return !!!demographicsTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === "Medical Condition" && insight.action === "ADD") {
      return !!!medConditionTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === "Intervention" && insight.action === "ADD") {
      return !!!interventionTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === 'Lab / Test' && insight.action === "ADD") {
      return !!!labTestTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === "Demographics" && insight.action === "REMOVE"
    ) {
      return !!demographicsTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === "Medical Condition" && insight.action === "REMOVE") {
      return !!medConditionTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === "Intervention" && insight.action === "REMOVE") {
      return !!interventionTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }

    if (insight.category === 'Lab / Test' && insight.action === "REMOVE") {
      return !!labTestTableData.find(item => item['Eligibility Criteria'] === insight.criteria && item. negation === insight.negation
      );
    }
  });

  const [ieActiveKey, setIeActiveKey] = useState(() => {
      const storedData = JSON.parse(localStorage.getItem('collapseCharts'));
      if(IEType==='Inclusion Criteria') { return storedData ? storedData.inclusionCollapse : ['1']; }
      else if (IEType==='Exclusion Criteria') { return storedData ? storedData.exclusionCollapse : ['1']; }
      else { return ['1'] }

    });

  function ieCallback(key) {
   const storedData = JSON.parse(localStorage.getItem('collapseCharts'));
    if (storedData) {

      if(IEType==='Inclusion Criteria') { storedData.inclusionCollapse = key; }
      else if (IEType==='Exclusion Criteria') { storedData.exclusionCollapse = key; }

     const updatedDataString = JSON.stringify(storedData);
     localStorage.setItem('collapseCharts', updatedDataString);
    }else{
      let inclusionCollapse = IEType==='Inclusion Criteria' ? key : ['1'];
      let exclusionCollapse = IEType==='Exclusion Criteria' ? key : ['1'];
      localStorage.setItem('collapseCharts', JSON.stringify({"endpointCollapse" : ['1'],
                                                "inclusionCollapse" : inclusionCollapse,
                                                "exclusionCollapse" : exclusionCollapse,
                                                "soaCollapse" : ['1']
                                                }));
    }
    setIeActiveKey(key)
  }

  useEffect(() => {
    setIeActiveKey(ieActiveKey)
  }, [ieActiveKey]);


  const [currentIndex, setCurrentIndex] = useState(3);
  const [addInsightsModal, setAddInsightsModal] = useState(false)
  const [insightSelected, setInsightSelected] = useState({})
  const [insightRecordSelected, setInsightRecordSelected] = useState({})

  const findElementsFromInsights = (key) => { 
    let newItem
    switch(key.category.charAt(0)) {
      case "D":
        let indexdemographicsElements = demographicsElements.findIndex((domain) => key.criteria == domain['Eligibility Criteria'] && key.negation === domain.negation)
        let detailDemographics 
        let indexDetailDemographics
        indexDetailDemographics = originDemographics.findIndex((domain) => key.criteria == domain['Text'] && key.negation === domain.negation)
        indexDetailDemographics>-1?detailDemographics = originDemographics[indexDetailDemographics]:[]
    
        if(indexdemographicsElements < 0 && key.action === "ADD"){
          newItem = {
            "Eligibility Criteria": key.criteria,
            "historical_value_free_text": formatHistoryValue(detailDemographics),
            "user_value_free_text": formatValue(detailDemographics),
            "rawValue": detailDemographics.Value,
            "historical_timeframe": formatHistoryTime(detailDemographics),
            "user_timeframe": formatTime(detailDemographics),
            "historical_roa":detailDemographics.historical_roa,
            "user_roa":detailDemographics.user_roa,
            "historical_acuity":detailDemographics.historical_acuity,
            "user_acuity":detailDemographics.user_acuity,
            "historical_treatment":detailDemographics.historical_treatment,
            "historical_anatomical_site":detailDemographics.historical_anatomical_site,
            "user_treatment":detailDemographics.user_treatment,
            "user_anatomical_site":detailDemographics.user_anatomical_site,
            "Frequency":detailDemographics.Frequency,
            "Detail":detailDemographics.details,
            "negation":detailDemographics.negation,
            "criteria_category":detailDemographics.criteria_category,
          } 
          props.updateIEActivities({ 
            insight_type: 'demographics'
          })
        } 
      break;
      case "M":
        let indexmedConditionElements = medConditionElements.findIndex((domain) => key.criteria == domain['Eligibility Criteria'] && key.negation === domain.negation)
        let detailmedCondition
        let indexDetailmedCondition
        indexDetailmedCondition = originMedCondition.findIndex((domain) => key.criteria == domain['Text'] && key.negation === domain.negation)
        indexDetailmedCondition>-1?detailmedCondition = originMedCondition[indexDetailmedCondition]:[]

        if(indexmedConditionElements < 0 && key.action === "ADD"){
          newItem = {
            "Eligibility Criteria": key.criteria,
            "historical_value_free_text": formatHistoryValue(detailmedCondition),
            "user_value_free_text": formatValue(detailmedCondition),
            "rawValue": detailmedCondition.Value,
            "historical_timeframe": formatHistoryTime(detailmedCondition),
            "user_timeframe": formatTime(detailmedCondition),
            "historical_roa":detailmedCondition.historical_roa,
            "user_roa":detailmedCondition.user_roa,
            "historical_acuity":detailmedCondition.historical_acuity,
            "user_acuity":detailmedCondition.user_acuity,
            "historical_treatment":detailmedCondition.historical_treatment,
            "historical_anatomical_site":detailmedCondition.historical_anatomical_site,
            "user_treatment":detailmedCondition.user_treatment,
            "user_anatomical_site":detailmedCondition.user_anatomical_site,
            "Frequency":detailmedCondition.Frequency,
            "Detail":detailmedCondition.details,
            "negation":detailmedCondition.negation,
            "criteria_category":detailmedCondition.criteria_category,
          } 
          props.updateIEActivities({ 
            insight_type: 'medical'
          })
        } 
        break;
        case "I":
          let indexinterventionElements = interventionElements.findIndex((domain) => key.criteria == domain['Eligibility Criteria'] && key.negation === domain.negation)
          let detailintervention 
          let indexDetailintervention
          indexDetailintervention = originIntervention.findIndex((domain) => key.criteria == domain['Text'] && key.negation === domain.negation)
          indexDetailintervention>-1?detailintervention = originIntervention[indexDetailintervention]:[]

          if(indexinterventionElements < 0 && key.action === "ADD"){
            newItem = {
              "Eligibility Criteria": key.criteria,
              "historical_value_free_text": formatHistoryValue(detailintervention),
              "user_value_free_text": formatValue(detailintervention),
              "rawValue": detailintervention.Value,
              "historical_timeframe": formatHistoryTime(detailintervention),
              "user_timeframe": formatTime(detailintervention),
              "historical_roa":detailintervention.historical_roa,
              "user_roa":detailintervention.user_roa,
              "historical_acuity":detailintervention.historical_acuity,
              "user_acuity":detailintervention.user_acuity,
              "historical_treatment":detailintervention.historical_treatment,
              "historical_anatomical_site":detailintervention.historical_anatomical_site,
              "user_treatment":detailintervention.user_treatment,
              "user_anatomical_site":detailintervention.user_anatomical_site,
              "Frequency":detailintervention.Frequency,
              "Detail":detailintervention.details,
              "negation":detailintervention.negation,
              "criteria_category":detailintervention.criteria_category,
            } 
          } 
          props.updateIEActivities({ 
            insight_type: 'intervention'
          })
        break;
      case 'L':
        let indexlabTestElements = labTestElements.findIndex((domain) => key.criteria == domain['Eligibility Criteria'] && key.negation === domain.negation)
        let detaillabTest 
        let indexDetaillabTest
        indexDetaillabTest = originLabTest.findIndex((domain) => key.criteria == domain['Text'] && key.negation === domain.negation)
        indexDetaillabTest>-1?detaillabTest = originLabTest[indexDetaillabTest]:[]

        if(indexlabTestElements < 0 && key.action === "ADD"){
          newItem = {
            "Eligibility Criteria": key.criteria,
            "historical_value_free_text": formatHistoryValue(detaillabTest),
            "user_value_free_text": formatValue(detaillabTest),
            "rawValue": detaillabTest.Value,
            "historical_timeframe": formatHistoryTime(detaillabTest),
            "user_timeframe": formatTime(detaillabTest),
            "historical_roa":detaillabTest.historical_roa,
            "user_roa":detaillabTest.user_roa,
            "historical_acuity":detaillabTest.historical_acuity,
            "user_acuity":detaillabTest.user_acuity,
            "historical_treatment":detaillabTest.historical_treatment,
            "historical_anatomical_site":detaillabTest.historical_anatomical_site,
            "user_treatment":detaillabTest.user_treatment,
            "user_anatomical_site":detaillabTest.user_anatomical_site,
            "Frequency":detaillabTest.Frequency,
            "Detail":detaillabTest.details,
            "negation":detaillabTest.negation,
            "criteria_category":detaillabTest.criteria_category,
          }
          props.updateIEActivities({ 
            insight_type: 'labs'
          })
        } 
      break;
    }
    return  newItem;
  }

  const resetInsightsModal = (insights) => { 
    setAddInsightsModal(false) 
    setInsightRecordSelected({})
    setInsightSelected({})
    props.updateIEActivities({ 
      insight_type: ''
    })
    props.resetInsightsData(insights)
  }

  const handleInsights = (insight, action) => { 
    if(action == 'add') { 
      setAddInsightsModal(true)
      let selectedItem; 
      const activeTabKey = JSON.parse(localStorage.getItem('activeTabKey'))
      if(activeTabKey == '1') {
        selectedItem  = findElementsFromInsights(insight);
        props.updateTrial(1, 1);
      } else if(activeTabKey == '2') {
        selectedItem  = findElementsFromInsights(insight);
        props.updateTrial(2, 1)
      }
      setInsightSelected(selectedItem)
      setInsightRecordSelected(insight) 
      return;
    }
    onInsightClick(insight);
    setCurrentIndex(currentIndex + 1);
  };

const handleDismiss = (insight) => {
  onDismiss(insight);
  setCurrentIndex(currentIndex + 1);
};

  return (  
  <>
    <div className="ie-library-container">
      <Row className="scenarios-actions-container">
        <Col span={iELibrarayPanelStatus ? 18 : 23} className="left-content-container" style={{paddingRight: '2%'}}>
          <div className="scenarios-heading-left"> 
          </div>
          <Collapse className="IEChartCollapsible" activeKey={ieActiveKey} onChange={ieCallback} expandIconPosition="right" >
              <Panel header={<span style={{fontSize:'26px'}}>Scenario impact summary</span>} key="1" forceRender={false} >
              <Row className="summary-container">
              <Col span={11} className="chart-wrapper">
                <div className="chart-header">
                  <div className="title">
                  Protocol amendment
                  </div>
                </div>
                <div className="chart-container">
                {par_historical_trial_average !== 0 && par_historical_trial_average !== null?
                  (
                  <>
                    <p className="description"><strong>{criteria_par_amendment_count}/{criteria_count} </strong> entities associated with historical amendments</p>
                    <div className="center-box">
                      <div className="pie-width">
                        <ReactECharts
                          option={amendmentRateoption}
                          style={{ height: 190}}
                          />
                      </div>
                      <div className="copy-width">
                        <p className="label"><strong>{protocol_amendment_rate||"0"} </strong>of the entities you selected are associated with a protocol amendment in similar historical trials</p>
                        <span 
                        className="detail" 
                        onClick={onClickPARDetail} 
                        >
                          See details
                        </span>
                      </div>
                    </div>
                  </>
                  ) : (
                    <>
                    <p className="description"></p>
                    <div className="center-box">
                      <div className="pie-width">
                        <ReactECharts
                          option={pieChartNullOption}
                          style={{ height: 190}}
                          />
                      </div>
                      <div className="copy-width">
                        <p className="label" style={{color: '#919191',paddingTop:'20px'}}>Protocol amendment rate is not available based on your similar historical trial list</p>
                      </div>
                    </div>
                    </>
                  )}
                  <div className="legend">
                    <div className="item-desc">
                      <div className="item">
                        <div className="bar-item item1"></div>
                        <span>Labs / tests</span>
                      </div>
                      <div className="item">
                        <span className="bar-item item2"></span>
                        <span>Intervention</span>
                      </div>
                    </div>
                    <div className="item-desc">
                      <div className="item">
                        <span className="bar-item item3"></span>
                        <span>Demographics</span>
                      </div>
                      <div className="item">
                        <span className="bar-item item4"></span>
                        <span>Medical condition</span>
                      </div>
                    </div>
                  </div>
                </div>                  
              </Col> 
              <Col span={11} className="chart-wrapper">
                <div className="chart-header">
                  <div className="title">
                  Screen failure
                  </div>
                </div>
                <div className="chart-container">
                {sfr_historical_trial_average !== 0 && sfr_historical_trial_average !== null?
                  (<>
                  <p className="description"><strong>{criteria_sfr_amendment_count}/{criteria_count}</strong> entities associated with high screen failure</p>
                  <div className="center-box">
                    <div className="pie-width">
                      <ReactECharts
                        option={screenFailureOption}
                        style={{ height: 190}}
                        />
                    </div>
                    <div className="copy-width">
                      <p className="label"><strong>{screen_failure_rate||"0"}</strong> of the entities in your scenario have been associated with high screen failure, compared to <strong>{Math.round(sfr_historical_trial_average * 10000) / 100 + "%"}</strong> in similar historical trials</p>
                      <Popover className="detail" content={detailContent('SFR')}  placement="bottom" overlayClassName="detail-table-wrapper">See details</Popover>
                    </div>
                  </div>
                  </>):
                  (<>
                    <p className="description"></p>
                    <div className="center-box">
                      <div className="pie-width">
                        <ReactECharts
                          option={pieChartNullOption}
                          style={{ height: 190}}
                          />
                      </div>
                      <div className="copy-width">
                        <p className="label" style={{color: '#919191',paddingTop:'20px'}}>Screen failure rate is not available based on your similar historical trials list </p>
                      </div>
                    </div>
                    </>
                  )
                  }
                  <div className="legend">
                    <div className="item-desc">
                      <div className="item">
                        <div className="bar-item item1"></div>
                        <span>Labs / tests</span>
                      </div>
                      <div className="item">
                        <span className="bar-item item2"></span>
                        <span>Intervention</span>
                      </div>
                    </div>
                    <div className="item-desc">
                      <div className="item">
                        <span className="bar-item item3"></span>
                        <span>Demographics</span>
                      </div>
                      <div className="item">
                        <span className="bar-item item4"></span>
                        <span>Medical condition</span>
                      </div>
                    </div>
                  </div>
                </div>                  
              </Col> 
            </Row> 
          </Panel>
        </Collapse>
          <Row className="table-container">
            <Col span={24} className="container-top">
              <div className="scenarios-heading-left">
                <span>{toSentenceCase(IEType)}</span>
              </div>
              <div className="scenarios-heading-right">
                <div className='btn-scenarios-container-header'>
                  <Button 
                    className="ie-btn" 
                    onClick={showIEPage} 
                    style={{zIndex: 1}}> 
                    <PlusCircleOutlined className="ie-activity-icon" /> Add criteria 
                  </Button>
                  <Button 
                    type="primary" 
                    onClick={saveCriteria} 
                    disabled={readOnlyAccess || !isAdmin && scenario?.is_template ? true : false} 
                    className="save_ie_btn"
                    style={{zIndex: 1}}>
                      Save
                  </Button>
                </div>
              </div>
            </Col>
            <Col span={24} className="event-dashboard" style={{ height: "700px", overflowX: "scroll", overflowY: "scroll" }}>
              <div className="collapse-inner">
                <div className="criteria-list">
                  <div className="list-columns">
                    <Row>
                        <Col span={3}><div className="col-item">Entity</div></Col>
                        <Col span={3}><div className="col-item">Historical entity frequency</div></Col>
                        <Col span={3}><div className="col-item">Values</div></Col>
                        <Col span={3}><div className="col-item">Timeframe</div></Col>
                        <Col span={3}><div className="col-item">RoA</div></Col>
                        <Col span={3}><div className="col-item">Acuity</div></Col>
                        <Col span={3}><div className="col-item">Treatment modifier</div></Col>
                        <Col span={2}><div className="col-item">Anatomical site</div></Col>
                        <Col span={1}><div className="col-item">Actions</div></Col>
                    </Row>
                  </div>
                </div>
                <div className="sectionPanel">
                    <NewEditTable updateCriteria={updateCriteria} tableIndex={2}
                      data={demographicsTableData}
                      libraryData={originDemographics}
                      defaultActiveKey={defaultActiveKey}
                      collapsible={collapsible} panelHeader={"Demographics"} 
                      addInsightsModal={addInsightsModal}
                      insightSelected={insightSelected}
                      insightRecordSelected={insightRecordSelected}
                      resetInsightsModal={resetInsightsModal}
                    />
                    <NewEditTable updateCriteria={updateCriteria} tableIndex={3}
                      data={medConditionTableData}
                      libraryData={originMedCondition}
                      defaultActiveKey={defaultActiveKey}
                      collapsible={collapsible} panelHeader={"Medical condition"} 
                      addInsightsModal={addInsightsModal}
                      insightSelected={insightSelected}
                      insightRecordSelected={insightRecordSelected}
                      resetInsightsModal={resetInsightsModal}
                        />
                    <NewEditTable updateCriteria={updateCriteria} tableIndex={4}
                      data={interventionTableData}
                      libraryData={originIntervention}
                      defaultActiveKey={defaultActiveKey}
                      collapsible={collapsible} panelHeader={"Intervention"} 
                      addInsightsModal={addInsightsModal}
                      insightSelected={insightSelected}
                      insightRecordSelected={insightRecordSelected}
                      resetInsightsModal={resetInsightsModal}
                    />
                    <NewEditTable updateCriteria={updateCriteria} tableIndex={5}
                      data={labTestTableData}
                      libraryData={originLabTest}
                      defaultActiveKey={defaultActiveKey}
                      collapsible={collapsible} panelHeader={"Lab / Test"} 
                      addInsightsModal={addInsightsModal}
                      insightSelected={insightSelected}
                      insightRecordSelected={insightRecordSelected}
                      resetInsightsModal={resetInsightsModal}
                    />
                </div>
              </div>
            </Col>
          </Row>
          <br />
        </Col>
        <Col span={iELibrarayPanelStatus ? 6: 1} className="right-insight-container"
         >
          <Row>
            {eventPanel=="2"&&(
            <Col span={21} className="left-insight" style={{
              backgroundColor: '#F8F8F8'
            }}>
              <Row style={{backgroundColor: '#F8F8F8'}}>
                <Col span={24}>
                  <div className="item-header">
                  <span> Insights  </span>
                  </div>
                </Col>
                <Col span={24} className="content-outer insight-box-wrapper">
                {insightEvent && filterAddedInsights(insightEvent).filter(o => o.action === "ADD").slice(0, 3).map((item) => {
                    return (
                      <div className="insight-box">
                      <div className="head">Suggested to add</div>
                      <div className="content">
                      <Tooltip title={`${item.negation?'Negated Entity':''}`} placement="topLeft">
                      <span style={  { color: '#ca4a04', display: item.negation ?'inline-block':'none', padding: '6px', verticalAlign: 'super', width: '25px', fontSize: '18px'}}>{item.negation ? '≠' : ''}</span>
                      </Tooltip> <b>{item.criteria}</b> occurs in <b>{Math.round(item.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider adding it to your scenario.
                      </div>
                      <div className="button-area">
                        <span className="button-left" onClick={e=>handleInsights(item, 'add')}>
                          <PlusOutlined style={{margin:"0 3px 0 0"}}/> Add Criteria
                        </span>
                        <span className="button-right" onClick={e=>handleDismiss(item)}>
                          <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                        </span>
                      </div>
                    </div>
                    )
                  })}
                  {insightEvent && filterAddedInsights(insightEvent).filter(i => i.action === "REMOVE").slice(0,3).map((o) => {
                    
                      return (
                        <div className="insight-box">
                        <div className="head">Suggested to remove</div>
                        <div className="content"> 
                        <Tooltip title={`${o.negation?'Negated Entity':''}`} placement="topLeft">
                        <span style={  { color: '#ca4a04', display: o.negation ?'inline-block':'none', padding: '6px', width: '25px', fontSize: '18px'}}>{o.negation ? '≠' : ''}</span>
                        </Tooltip><b>{o.criteria}</b> occurs in <b>{Math.round(o.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider removing it from your scenario.
                        </div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>handleInsights(o, 'remove')}>
                            <MinusOutlined style={{margin:"0 3px 0 0"}}/> Remove Criteria
                          </span>
                          <span className="button-right" onClick={e=>handleDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    )
                  })}
                </Col>
              </Row>
            </Col>
            )}
            <Col span={1} className="right-icon" style={{maxWidth: '50px', minWidth: '50px', background: '#FFFFFF'}}>
              <div className={`side-toolbar ${eventLib > 0 ? '' : ''}`}> 
                <Badge style={{marginTop: '20px'}} count={insightEvent?filterAddedInsights(insightEvent).length:0} showZero={insightEvent && filterAddedInsights(insightEvent).length == 0 ? true : false }>
                <Tooltip placement="right" title={'Insights'}>
                  {eventPanel==="2"&&(
                    <CarryOutFilled style={{color:"#404042", fontSize: "18px", marginLeft: "15px", marginTop: "20px", paddingTop: "12px", cursor: "pointer"}} onClick={()=> {
                      setEventPanel("1"); ieInsightsToggleHandler(false)
                    }}/>
                  )}
                  {eventPanel==="1"&&(
                    <CarryOutFilled style={{color:"#999999", fontSize: "18px", marginLeft: "15px", marginTop: "20px", paddingTop: "12px", cursor: "pointer"}} onClick={()=> {
                      setEventPanel("2")
                      ieInsightsToggleHandler(true)
                    }}/>
                  )}
                </Tooltip>
                </Badge>
                {!iELibrarayPanelStatus &&  <div className="action-wrapper"></div>} 
              </div>
            </Col>
          </Row> 
        </Col>
      </Row>
    </div>
  </>)
}

const mapDispatchToProps = (dispatch) => ({
  createTrial: (val) => dispatch(createActions.createTrial(val)),
  createSoa: (val) => dispatch(createActions.createSoa(val)),
  updateSoaActivities: (val) => dispatch(createActions.updateSoaActivities(val)),
  updateIEActivities: (val) => dispatch(createActions.updateIEActivities(val))
});

const mapStateToProps = (state) => ({
  newTrial: state.trialReducer,
  newSoa: state.soaReducer,
  newIE: state.ieReducer
});
export default connect(mapStateToProps, mapDispatchToProps)(IELibrary);

 
